import type { ComponentProps, PropsWithChildren } from 'react'
import React, { forwardRef } from 'react'
import _FloatingDropdown from '../_FloatingDropdown'
import DropdownListSheet from './DropdownListSheet'

type InheritedSheetProps = Pick<ComponentProps<typeof DropdownListSheet>, 'size' | 'width'>
type InheritedFloatingDropdownProps = Pick<ComponentProps<typeof _FloatingDropdown>, 'placement' | 'crossAxisShift' | 'autoHeight' | 'anchorRef' | 'anchorOffset' | 'boundaryRef' | 'triggerRef' | 'open' | 'portaled' | 'onClose' | 'id' | 'keepOpenOnModalClick'>

interface Props extends PropsWithChildren, Utils.PropsWithDataAttributes, InheritedSheetProps, InheritedFloatingDropdownProps {
  enableFlip?: boolean
}

const DropdownListBase = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    size,
    width,
    placement,
    enableFlip,
    crossAxisShift,
    autoHeight,
    open,
    anchorRef,
    anchorOffset,
    boundaryRef,
    triggerRef,
    id,
    onClose,
    portaled,
    ...rest
  } = props

  return <_FloatingDropdown
    {...rest}
    ref={ref}
    width={size === 'fill-anchor' ? 'match-anchor' : 'auto'}
    placement={placement}
    anchorRef={anchorRef}
    anchorOffset={anchorOffset}
    boundaryRef={boundaryRef}
    triggerRef={triggerRef}
    open={open}
    disableFlip={!enableFlip}
    crossAxisShift={crossAxisShift}
    autoHeight={autoHeight}
    id={id}
    onClose={onClose}
    portaled={portaled}
  >
    <DropdownListSheet size={size} width={width} autoHeight={autoHeight}>
      {children}
    </DropdownListSheet>
  </_FloatingDropdown>
})

DropdownListBase.displayName = 'DropdownListBase'

export default DropdownListBase
